import { API, IResponse, onDayDelay } from "./API";

export interface IFetchGradeEntity {
  _code: string;
  _id: number;
  _isActive: boolean;
  _maxAge: number;
  _minAge: number;
  _nameAr: string;
  _nameEn: string;
  _nameFr: string;
}

interface IFetchGradeResponse extends IResponse {
  _entity: IFetchGradeEntity[];
}

const commonServices = API.injectEndpoints({
  endpoints(build) {
    return {
      fetchGrades: build.query<IFetchGradeResponse, void>({
        query() {
          return `/cms/grades?status=active`;
        },
        keepUnusedDataFor: onDayDelay,
      }),
    };
  },
});

export const { useFetchGradesQuery } = commonServices;
